import {
  POLICIES_SET_LOADING,
  POLICIES_SET_ERROR,
  POLICIES_SET_POLICIES,
  POLICIES_SET_GROUPS,
  POLICIES_SET_PAGINATION,
  POLICIES_FETCH_POLICIES,
  POLICIES_FETCH_GROUPS,
  POLICIES_CLEAR_ERROR,
  POLICIES_GET_POLICIES,
  POLICIES_GET_PAGINATION,
  POLICIES_GET_LOADING,
  POLICIES_GET_ERROR
} from './types';
import { policyService } from '@/network';
import {
  handleAsyncAction,
  createAsyncState,
  createAsyncMutations
} from '@/utils/helpers/store';

const state = {
  policies: [],
  groups: [],
  pagination: {
    page: 1,
    pages: null,
    size: 10,
    count: 0
  },
  ...createAsyncState(['fetchPolicies', 'fetchGroups'])
};

const mutations = {
  ...createAsyncMutations(POLICIES_SET_LOADING, POLICIES_SET_ERROR),
  [POLICIES_SET_POLICIES](state, policies) {
    state.policies = policies;
  },
  [POLICIES_SET_GROUPS](state, groups) {
    state.groups = groups;
  },
  [POLICIES_SET_PAGINATION](state, pagination) {
    state.pagination = pagination;
  }
};

const actions = {
  async [POLICIES_FETCH_POLICIES](
    { commit },
    {
      companyIds,
      insuranceCompanyId,
      employeeId,
      employeeStatus,
      status,
      page,
      size
    }
  ) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchPolicies',
      errorMessage: 'Ocurrió un error al obtener las pólizas',
      asyncOperation: async () => {
        const hasPagination = size > 0;

        const query = {
          companyIds,
          insuranceCompanyId,
          employeeId,
          employeeStatus,
          status
        };

        let policies;
        if (hasPagination) {
          const { rows, ...pagination } = await policyService.findAll({
            ...query,
            page,
            size
          });
          policies = rows;
          commit(POLICIES_SET_PAGINATION, pagination);
        } else {
          policies = await policyService.findAll({
            ...query
          });
        }
        commit(POLICIES_SET_POLICIES, policies);
        return policies;
      },
      setLoading: POLICIES_SET_LOADING,
      setError: POLICIES_SET_ERROR
    });
  },

  async [POLICIES_FETCH_GROUPS](
    { commit },
    { policyId, employeeId, employeeStatus, page, size }
  ) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchGroups',
      errorMessage: 'Ocurrió un error al obtener los grupos de una póliza',
      asyncOperation: async () => {
        const hasPagination = size > 0;

        const query = {
          policyId,
          employeeId,
          employeeStatus
        };

        let groups;
        if (hasPagination) {
          const { rows, ...pagination } = await policyService.getGroups({
            ...query,
            page,
            size
          });
          groups = rows;
          commit(POLICIES_SET_PAGINATION, pagination);
        } else {
          groups = await policyService.getGroups({
            ...query
          });
        }
        commit(POLICIES_SET_GROUPS, groups);
        return groups;
      },
      setLoading: POLICIES_SET_LOADING,
      setError: POLICIES_SET_ERROR
    });
  },

  [POLICIES_CLEAR_ERROR]({ commit }, { type }) {
    commit(POLICIES_SET_ERROR, {
      type,
      value: null
    });
  }
};

const getters = {
  [POLICIES_GET_POLICIES]: (state) => state.policies,
  [POLICIES_GET_PAGINATION]: (state) => state.pagination,
  [POLICIES_GET_LOADING]: (state) => state.loading,
  [POLICIES_GET_ERROR]: (state) => state.error
};

export default {
  state,
  mutations,
  actions,
  getters
};
